var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRestart = function SvgRestart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.359 6.851a7.95 7.95 0 0 1 6.48-2.31c3.67.37 6.69 3.35 7.1 7.02.55 4.85-3.2 8.94-7.93 8.94a7.98 7.98 0 0 1-7.21-4.56c-.32-.67.16-1.44.9-1.44.37 0 .72.2.88.53a5.994 5.994 0 0 0 6.8 3.31c2.22-.49 4.01-2.3 4.48-4.52a6.002 6.002 0 0 0-5.85-7.32c-1.66 0-3.14.69-4.22 1.78l1.51 1.51c.63.63.19 1.71-.7 1.71h-3.59c-.55 0-1-.45-1-1v-3.59c0-.89 1.08-1.34 1.71-.71l.64.65Z",
    fill: "currentColor"
  })));
};
export default SvgRestart;